// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import {Link} from 'react-router-dom';
import {isIOS, isSafari, isMobile, isTablet, isBrowser} from 'react-device-detect';
import Modal from 'react-modal';
import { colors, btn, form, modal, search as searchStyles, chipWrap } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg     = type === 'error' ? colors.dangerLt  : colors.successLt;
  const color  = type === 'error' ? colors.danger     : colors.success;
  const border = type === 'error' ? '#fca5a5'          : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: `1px solid ${border}`, fontSize: 13,
    }}>
      <span style={{ color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

class AddTournamentTeamMember extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      tournament_id: props.tournament_id,
      competition_id: props.competition_id,
      team_id: props.team_id,
      team_name: props.team_name,
      customer_search_list: [],
      tournaments: [],
      tournament_teams: [],
      team_members: [],
      tournament_details: {
        mobile_no: '',
        customer_id: '',
        name: '',
        tournament_team: props.team_id,
        amount: 0,
        cust_name: '',
        cust_mobile_no: '',
      },
      venues: [],
      data_uploaded: false,
      data_error: false,
      search: false,
      search_loading: false,
      dialog_open: false,
      addPlayerView: true,
      team_list: [],
      modal_open: true,
      toast: null,
      add_user_toast: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
    this.getTeamList = this.getTeamList.bind(this);

    this.chipStyle        = { margin: !isMobile ? 1 : 4, backgroundColor: 'lightgreen' };
    this.chipStyleSuggest = { margin: isMobile ? 1 : 4 };
    this.chipWrapper      = { display: 'flex', flexWrap: 'wrap' };
  }

  componentDidMount() {
    console.log(this.state);
    this.getTeamList();
  }

  showToast(message, type = 'error')        { this.setState({ toast: { message, type } }); }
  showAddUserToast(message, type = 'error') { this.setState({ add_user_toast: { message, type } }); }

  getSearchList(mobile_no) {
    this.setState({ search_loading: true, toast: null });
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'search': mobile_no, 'competition_id': this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        if (data.Message) {
          this.setState({ customer_search_list: [], search: false, search_loading: false });
          this.showToast(data.Message);
          return;
        }
        this.setState({
          customer_search_list: Array.isArray(data.results) ? data.results : [],
          search: true,
          search_loading: false,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({ customer_search_list: [], search: false, search_loading: false });
        this.showToast(error && error.message ? error.message : 'Search failed. Please try again.');
      });
  }

  getTeamList() {
    const url = `${getLocationOrigin()}/eagleeye/get_tournament_teams_details/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({ 'competition_id': this.state.competition_id });
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => this.setState({ team_list: data.teamlist }))
      .catch(error => { console.log(error); alert(error.message); });
  }

  postaddTournamentMember(data, props) {
    console.log(data);
    const url = `${getLocationOrigin()}/eagleeye/add_tournament_member/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({
      'customer_list': this.state.team_members,
      'tournament_team': data.tournament_team,
      'amount': data.amount,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(function(response) { alert(response.message); window.location.reload(); })
      .catch(error => { console.log(error); alert(error.message); });
  }

  handleOpen  = () => { this.setState({ dialog_open: true }); };
  handleClose = () => { this.setState({ dialog_open: false, add_user_toast: null }); };

  handleChange(event) {
    console.log(event.target.name, event.target.value);
    const name = event.target.name;
    var new_selected_one = Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.value;
    this.setState({ tournament_details: new_selected_one });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentMember(this.state.tournament_details, this.props);
    console.log('post');
    console.log(this.state);
  }

  handleCustomerSubmit() {
    console.log('post');
    if (!this.state.tournament_details.cust_name) { this.showAddUserToast('Enter name'); return; }
    if (!this.state.tournament_details.cust_mobile_no || String(this.state.tournament_details.cust_mobile_no).length !== 10) {
      this.showAddUserToast('Enter a valid 10-digit mobile number'); return;
    }
    const url = `${getLocationOrigin()}/eagleeye/add_new_customer_tournament/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = { 'content-type': 'application/json' };
    options['body'] = JSON.stringify({
      'customer_name': this.state.tournament_details.cust_name,
      'customer_mobile': this.state.tournament_details.cust_mobile_no,
      'tournament_id': this.state.tournament_id,
    });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .catch(error => { console.log(error); this.showAddUserToast(error && error.message ? error.message : 'Failed to add user'); })
      .then(data => {
        if (!data) return;
        if(data.success) {
          var team_members = Object.assign([], this.state.team_members);
          team_members.push({ 'id': data.customer.id, 'name': data.customer.name, 'photo': "http://www.sporthood.in/assets/img/avatar.png" });
          this.setState({ team_members: team_members });
          this.handleClose();
        } else {
          this.showAddUserToast(data.message || 'Something went wrong');
        }
      });
  }

  searchCustomer() {
    const term = this.state.tournament_details.mobile_no;
    if (!term || String(term).trim() === '') { this.showToast('Search cannot be blank'); return; }
    if (String(term).trim().length < 3) { this.showToast('Enter at least 3 characters to search'); return; }
    this.getSearchList(term);
  }

  setSearch(name, mobile, id) {
    var new_selected_one = Object.assign({}, this.state.tournament_details);
    var team_members = Object.assign([], this.state.team_members);
    team_members.push({ 'id': id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png" });
    new_selected_one['mobile_no'] = mobile;
    new_selected_one['name'] = name;
    new_selected_one['customer_id'] = id;
    this.setState({ tournament_details: new_selected_one, search: false, team_members: team_members });
  }

  handlePlayerSuggest(name, mobile, id) {
    var new_selected_one = Object.assign({}, this.state.tournament_details);
    var team_members = Object.assign([], this.state.team_members);
    var already_added = team_members.map(x => x.name);
    if(already_added.includes(name)) {
      this.showToast('Player already added');
      return false;
    } else {
      team_members.push({ 'id': id, 'name': name, 'photo': "http://www.sporthood.in/assets/img/avatar.png" });
      new_selected_one['mobile_no'] = mobile;
      new_selected_one['name'] = name;
      new_selected_one['customer_id'] = id;
      this.setState({ tournament_details: new_selected_one, search: false, team_members: team_members });
    }
  }

  handleRequestDelete = (key) => {
    var team_members = Object.assign([], this.state.team_members);
    console.log(team_members);
    const chipToDelete = team_members.findIndex(chip => chip.id == key);
    team_members.splice(chipToDelete, 1);
    this.setState({ team_members: team_members });
  };

  toAdd() { this.setState({ addPlayerView: !this.state.addPlayerView }); }

  renderChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleRequestDelete(data.id)} style={this.chipStyle}>
        <Avatar id={data.id} src={data.photo == 'http://www.sporthood.in/assets/img/avatar.png' ? data.photo : `https://api.sporthood.in/${data.photo}`} />
        {data.name}
      </Chip>
    );
  }

  renderPlayerSuggestion(data) {
    return (
      <Chip key={data.id} style={this.chipStyleSuggest} onClick={() => { this.handlePlayerSuggest(data.name, data.mobile_no, data.id); }}>
        <Avatar id={data.id} src={'http://www.sporthood.in/assets/img/avatar.png'} />
        {data.name}
      </Chip>
    );
  }

  renderNewUser() {
    return (
      <Modal
        isOpen={this.state.dialog_open}
        onRequestClose={this.handleClose}
        ariaHideApp={false}
        style={{
          overlay: { backgroundColor: 'rgba(17,24,39,.45)', zIndex: 1100 },
          content: {
            top: '50%', left: '50%', right: 'auto', bottom: 'auto',
            marginRight: '-50%', transform: 'translate(-50%,-50%)',
            padding: 0, border: 'none', borderRadius: 16,
            boxShadow: '0 8px 40px rgba(0,0,0,.18)',
            width: '90%', maxWidth: 400,
          },
        }}
      >
        <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", padding: '24px 24px 20px' }}>
          <h3 style={modal.title}>Add New Customer</h3>
          <Toast
            message={this.state.add_user_toast && this.state.add_user_toast.message}
            type={this.state.add_user_toast && this.state.add_user_toast.type}
            onClose={() => this.setState({ add_user_toast: null })}
          />
          <div style={form.row}>
            <div style={form.label}>Name</div>
            <input type="text" style={form.input} name="cust_name" className="required" value={this.state.value} onChange={this.handleChange} />
          </div>
          <div style={form.row}>
            <div style={form.label}>Mobile No</div>
            <input type="number" style={form.input} name="cust_mobile_no" className="required" value={this.state.value} onChange={this.handleChange} />
          </div>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
            <button type="button" style={btn.cancel} onClick={this.handleClose}>Cancel</button>
            <button type="button" style={btn.primary} onClick={this.handleCustomerSubmit}>Submit</button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    console.log("her in render");
    console.log(this.state.team_members);

    if(this.state.team_list) {
      var player_list = this.state.team_list.filter(x => x.team.name == this.state.team_name);
      if (player_list[0]) {
        var previous_player_list = player_list[0].previous_players;
      }
    }

    const { search, search_loading, customer_search_list, toast } = this.state;

    return (
      <div>
        {this.state.addPlayerView &&
          <Modal
            isOpen={this.state.modal_open}
            onRequestClose={() => { this.setState({ modal_open: false }); }}
            ariaHideApp={false}
            style={{
              overlay: { backgroundColor: 'rgba(17,24,39,.45)', zIndex: 1000 },
              content: {
                top: '50%', left: '50%', right: 'auto', bottom: 'auto',
                marginRight: '-50%', transform: 'translate(-50%,-50%)',
                padding: 0, border: 'none', borderRadius: 16,
                boxShadow: '0 8px 40px rgba(0,0,0,.18)',
                width: '90%', maxWidth: 540, maxHeight: '90vh', overflow: 'auto',
              },
            }}
          >
            <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif" }}>

              {/* Header */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 24px', borderBottom: `1px solid ${colors.border}` }}>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>Add Team Member</h3>
                <button
                  type="button"
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: colors.muted, fontSize: 18, lineHeight: 1 }}
                  onClick={() => { this.setState({ modal_open: false }); }}
                >✕</button>
              </div>

              <div style={{ padding: '20px 24px' }}>
                {/*
                <div style={{flexDirection: 'column'}}>
                  <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', margin: '13px'}}>
                    <Link to={`/crud/childProfile/${this.state.tournament_details.mobile_no}`}>
                      <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                      <span style={{fontSize: '100%', fontWeight: 600, margin: '4px'}}>Add Kid Profile</span>
                    </Link>
                  </button>
                </div> */}

                <Toast message={toast && toast.message} type={toast && toast.type} onClose={() => this.setState({ toast: null })} />

                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

                  {/* Customer search */}
                  <div style={form.row}>
                    <div style={form.label}>Customer Search</div>
                    <div style={{ ...form.searchWrap, flex: 1 }}>
                      <input
                        type="text"
                        name="mobile_no"
                        placeholder="Search (min 3 chars)…"
                        style={form.searchInput}
                        value={this.state.tournament_details.mobile_no}
                        onChange={this.handleChange}
                        onKeyDown={e => e.key === 'Enter' && (e.preventDefault(), this.searchCustomer())}
                      />
                      <button
                        type="button"
                        style={{ ...form.searchBtn, opacity: search_loading ? 0.6 : 1 }}
                        onClick={this.searchCustomer}
                        disabled={search_loading}
                      >
                        {search_loading ? '…' : '🔍'}
                      </button>
                      {/* + Add new user inline trigger */}
                      <button
                        type="button"
                        title="Add New User"
                        style={{ ...btn.outline, padding: '0 12px', borderRadius: '0 8px 8px 0', borderLeft: 'none', fontSize: 18, fontWeight: 700, lineHeight: '36px', flexShrink: 0 }}
                        onClick={this.handleOpen}
                      >+</button>
                    </div>
                  </div>

                  {/* Search results */}
                  {search && (
                    <div style={{ marginBottom: 14, paddingLeft: 140 }}>
                      {customer_search_list.length ? (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                          {customer_search_list.map(x => (
                            <button
                              key={x.id}
                              type="button"
                              style={{
                                textAlign: 'left', background: colors.bg, border: `1px solid ${colors.border}`,
                                borderRadius: 8, padding: '8px 12px', cursor: 'pointer', fontSize: 13,
                                fontFamily: 'inherit',
                              }}
                              onClick={() => this.setSearch(x.name, x.mobile_no, x.id)}
                              onMouseEnter={e => e.currentTarget.style.background = colors.brandLt}
                              onMouseLeave={e => e.currentTarget.style.background = colors.bg}
                            >
                              <div style={{ fontWeight: 600, color: colors.text }}>{x.name}: {x.mobile_no}</div>
                              <div style={{ fontSize: 12, color: colors.muted, marginTop: 2 }}>
                                {x.payment_status.status}
                                {x.payment_status.venue ? ` · ${x.payment_status.venue}` : ''}
                                {x.payment_status.age_group ? ` · ${x.payment_status.age_group}` : ''}
                                {x.payment_status.program ? ` · ${x.payment_status.program}` : ''}
                              </div>
                            </button>
                          ))}
                        </div>
                      ) : (
                        <div style={searchStyles.notFound}>
                          <span style={searchStyles.notFoundText}>Search customer not found</span>
                        </div>
                      )}
                    </div>
                  )}

                  {/* Selected players */}
                  {this.state.team_members.length > 0 && (
                    <div style={form.row}>
                      <div style={form.label}>Selected Players</div>
                      <div style={chipWrap}>{this.state.team_members.map(this.renderChip, this)}</div>
                    </div>
                  )}

                  {/* Player suggestion list */}
                  {this.state.team_list && previous_player_list && (
                    <div style={form.row}>
                      <div style={form.label}>Suggestions</div>
                      <div style={chipWrap}>{previous_player_list.map(this.renderPlayerSuggestion, this)}</div>
                    </div>
                  )}

                  {/* Tournament team display */}
                  <div style={form.row}>
                    <div style={form.label}>Tournament Team</div>
                    <div style={{ flex: 1, fontSize: 13, fontWeight: 600, color: colors.text, paddingTop: 4 }}>
                      {this.state.team_name}
                    </div>
                  </div>

                  {/*
                  <div style={form.row}>
                    <div style={form.label}>Amount Collected/Player</div>
                    <input type="number" style={form.input} name="amount" className="required" value={this.state.value} onChange={this.handleChange} />
                  </div>
                  */}

                  <div style={modal.footer}>
                    <button type="button" style={btn.cancel} onClick={() => { this.toAdd(); }}>Cancel</button>
                    <button type="submit" style={btn.primary}>Submit</button>
                  </div>

                </form>
              </div>
            </div>

            {/* Add New User modal */}
            {this.renderNewUser()}

          </Modal>
        }
      </div>
    );
  }
}

export default AddTournamentTeamMember;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournamentTeamMember/index.js